import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { WorkistLogo } from '../../core/components/WorkistLogo.tsx';

const FormNotAvailablePage = () => {
    const { t } = useTranslation('forms');
    return (
        <div className="h-full bg-surface-medium text-content-strong flex items-center justify-center overflow-y-auto">
            <div className="max-w-md text-center p-10 bg-surface-weak border border-solid border-line-weak rounded">
                <h1 className="text-xl font-semibold mb-3">{t('notAvailable.title')}</h1>
                <p className="text-content-medium mb-6">{t('notAvailable.body')}</p>
                <WorkistLogo className="h-5 w-auto mx-auto opacity-60" />
            </div>
        </div>
    );
};

export default FormNotAvailablePage;
